/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Item reducer
 */

import _merge from "lodash/merge";
import { Repo } from "@thenounproject/lingo-core";
import { createReducer } from "@reduxjs/toolkit";
import { fetchShowcaseKits } from "@queries/useShowcaseKits";

type Data = {
  kits?: Record<string, string>;
  items?: Record<string, string>;
  sections?: Record<string, string>;
  portals?: Record<string, string>;
  kitCollections?: Record<string, string>;
};

const shortIdReducer = createReducer<Data>({}, builder => {
  builder
    .addCase(fetchShowcaseKits.fulfilled, () => {
      // Do nothing
    })
    .addDefaultCase((state, action: any) => {
      const entities = action.payload?.entities ?? action.response?.entities;
      if (!entities) return state;
      const updates = Repo.getShortIdsFromEntities(entities);
      return _merge(state, updates);
    });
});

export default shortIdReducer;
